import React, { type ReactNode } from 'react';
import { Callout, type CalloutProps } from './Callout';
import { Button, type ButtonProps } from './buttons/Button';

export function NoItemsFound({
	itemCount,
	additionalActions,
	...props
}: Omit<CalloutProps, 'children'> &
	ButtonProps & {
		itemCount: number;
		additionalActions?: ReactNode;
		renderTable: () => ReactNode;
	}) {
	if (itemCount === 0) {
		return (
			<Callout {...props}>
				<Button actionType="add" intent="neutral" {...props} />
			</Callout>
		);
	}
	return (
		<div className="space-y-4">
			<div className="flex justify-end gap-2">
				{additionalActions}
				<Button actionType="add" intent="neutral" {...props} />
			</div>
			{props.renderTable()}
		</div>
	);
}
